export default "__VITE_ASSET__1GFLmj0w__"